import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function getWordCount(text) {
  if (!text || typeof text !== "string") return 0;
  return text
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0).length;
}

export function isWithinWordLimit(text, limit = 500) {
  return getWordCount(text) <= limit;
}

export function getCharCount(text) {
  if (!text || typeof text !== "string") return 0;
  return text.length;
}

export function isWithinCharLimit(text, limit = 500) {
  return getCharCount(text) <= limit;
}
